// extracted by mini-css-extract-plugin
export default {"profile":"profile_profile__D2u+P","img":"profile_img__1sjqF"};